import type { ValidationError } from '@volee/api-client'
import { isEmptyPatch } from '@volee/forms'

import { translateFieldError } from '../messages/field-errors.ts'

// The half that names this app's catalogue. The rest — `applyFieldErrors`, `isEmptyPatch`,
// `applyMissingRequired` — is `@volee/forms`, because it knows nothing about either reader.

/** A 422 over the form's own field names, or `undefined` when it marked none — which the
 * caller turns into a form-level message, so a 422 reaching no input never goes invisible. */
export function validationFieldErrors<TFields>(
  error: ValidationError,
  apiNames: Readonly<Record<string, keyof TFields & string>>,
): Record<string, string> | undefined {
  const perField: Record<string, string> = {}
  for (const [apiName, problems] of error.byField()) {
    const field = apiNames[apiName]
    const first = problems[0]
    if (field === undefined || first === undefined) continue
    perField[field] = translateFieldError(first)
  }
  return isEmptyPatch(perField) ? undefined : perField
}
